import React, {useState, useEffect} from "react";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import * as yup from 'yup';
import {API_ENDPOINT, APP_URL, APP_NAME, admin_phone, toast_anim} from '../config/Common'
import ScrollPageTop from '../../routes/ScrollPageTop'
import {Links} from '../../routes/PathLink'
import Seo from '../seo/seo'

import TextArea from '../../ui/text-area.tsx'
import Button from '../../ui/Button.tsx'
//import Input from '../../ui/Input.tsx'
import Input from '../../ui/input.jsx';
import PhoneInput from 'react-phone-input-2'

import {
   Control,
   FieldErrors,
   useForm,
   useFormState,
   useWatch,
   Controller
} from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

const formSchema = yup.object().shape({
   name: yup.string().required('Name is required'),
   email: yup.string().required('Email is required'),
   phone: yup.string().required('Phone Number is required').matches(/^[0-9]+$/, 'Phone Number must be only digits').min(10, 'Phone Number must be at least 10 digits'),
   enquiry_message: yup.string().required('Enquiry Message is required'), 
});

let defaultValues = {
   name:'',
   phone:'',
   email:'',  
   enquiry_message:'',
};

const EnquireProduct = (props) => {
   const [name, setName] = useState(localStorage.getItem('user_name'));
   const [email, setEmail] = useState(localStorage.getItem('email'));
   const [user_id, setUser_id] = useState(localStorage.getItem('user_id'));

   
   const [accessToken, setAccessToken] = useState(localStorage.getItem('access_token'))

   const [loading, setLoading] = useState(false);
   
   const { register, handleSubmit , control, reset, setValue, setError, formState: { errors },} = useForm({
      defaultValues: defaultValues,
      resolver: yupResolver(formSchema),
   });

  


   const {product} = props;
   const [pagecontent, setPagecontent] = useState(null);
   const [pagetitle, setPageTitle] = useState(null);
   
   const onSubmit = (values) => {
      
      let input = {...values, product:product, user_id:user_id };
      console.log('input====', input);
      setLoading(true)
      fetch(`${API_ENDPOINT}/send_enquiry_form`,{
         method: 'POST',
         headers : {        
            'Content-Type': 'application/json',
            'Accept': 'application/json', 
         },
         body: JSON.stringify(input)
      }).then(function (response) {
            return response.json();
      }).then( (result)=> {
         console.log('mail======',result);
         setLoading(false)
         if(result.status === 1){
            toast_anim(result?.message); 
             props.closeModal();
      
         }
      })
   }

   return(<div className="py-2"><form onSubmit={handleSubmit(onSubmit)}>              

      <Input                
         label={`Name`}
         {...register('name')}
         variant="outline"
         className="mb-5"
         error={errors.name?.message}
         required
      />
      <Input                
         label={`Phone Number`}
         {...register('phone')}
         variant="outline"
         className="mb-5"
         error={errors.phone?.message}
         required
         inputMode="numeric"
      /> 
      <Input                
         label={`Email`}
         {...register('email')}
         type="email"
         variant="outline"
         className="mb-5"
         error={errors.email?.message}
         required
      />     
      <TextArea
         label='Message'
         {...register('enquiry_message')}                        
         variant="outline"
         className="mb-5"
         error={errors.enquiry_message?.message}
         required
      />
      <div>
      <Button loading={loading}>
         Send
      </Button>

       <Button type="button" className="ml-2 bg-black" onClick={()=>{ props.closeModal() }} >
         Cancel
      </Button>

      </div>
   </form></div>)
}

export default EnquireProduct;